<template>
  <!-- 免费房间显示时间段配置 -->
  <div>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" title="配置盒子下架时间" width="850px"
      @close="closeConfigDialog">
      <el-alert title="下面的时间是下架时间区间，此时间区间之外是上架时间；盒子名称可填多个必须用英文逗号隔开" type="error" effect="dark" :closable="false">
      </el-alert><br>
      <p class="accumulated-line" style="line-height: 50px" v-for="(item, index) in dataList" :key="index">
        <span style="margin: 0px 10px">盒子{{ index + 1 }}</span>
        <el-input v-model="item.names" placeholder="请输入盒子名称（可填多个用英文逗号分隔）" style="width: 300px;margin-right: 10px;">
        </el-input>
        <el-time-picker v-model="item.start_time" :picker-options="{
          selectableRange: '00:00:00 - 23:59:59',
        }" value-format="HH:mm:ss" placeholder="下架开始时间" style="width: 150px">
        </el-time-picker>
        ——
        <el-time-picker v-model="item.end_time" :picker-options="{
          selectableRange: '00:00:00 - 23:59:59',
        }" value-format="HH:mm:ss" placeholder="下架结束时间" style="width: 150px">
        </el-time-picker>
        <i v-if="dataList.length > 1" class="el-icon-remove-outline reduce_btn" @click="reduceTextLine(index)">
        </i>
        <i v-if="dataList.length - 1 === index" class="el-icon-circle-plus-outline add_btn" @click="addTextLine"></i>
      </p>
      <p class="btn-box">
        <el-button style="margin-right: 20px" @click="closeConfigDialog">取消</el-button>
        <el-button type="primary" @click="submit" :loading="buttonLoading">确定</el-button>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
export default {
  components: {},
  props: {
    value: {
      type: Number,
      default: 1
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogLoading: false,//弹窗加载动画
      buttonLoading: false,//按钮加载动画
      dataList: [{ names: '', start_time: undefined, end_time: undefined }],//设置弹窗初始数据
    }
  },
  computed: {
    dialogVisible: {//显示标志
      get() {
        return this.visible
      },
      set() { }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.dataList=[{ names: '', start_time: undefined, end_time: undefined }]//初始化数据
        this.getData()
      }
    }
  },
  created() {
  },
  methods: {
    getData() {
      //获取表单数据
      this.loading = true
      getApiData(`up_down`).then(res => {
        if (res && res.length) {
          this.dataList = res

          //按时间进行从小到大排序
          for (let i = 0; i < this.dataList.length - 1; i++) {
            for (let j = 0; j < this.dataList.length - 1 - i; j++) {
              if (this.dataList[j].start_time > this.dataList[j + 1]
                .start_time) {
                let temp = this.dataList[j];
                this.dataList[j] = this.dataList[j + 1];
                this.dataList[j + 1] = temp;
              }
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    addTextLine() {
      //加行
      let params = { start_time: 0, end_time: 0 }
      this.dataList.push(params)
    },
    reduceTextLine(num) {
      //减行
      this.dataList.splice(num, 1)
    },
    submit() {
      //保存编辑好的表单信息
      this.buttonLoading = true

      //检测最大值不能小于最小值
      for (let i = 0, len = this.dataList.length; i < len; i++) {
        if (this.dataList[i] && (parseFloat(this.dataList[i].start_time) > parseFloat(this.dataList[i].end_time))) {
          this.$message.error(`第${i + 1}行，开始时间不能大于结束时间`)
          this.buttonLoading = false
          return
        }
        if (this.dataList[i] && (!this.dataList[i].start_time) && !this.dataList[i].end_time) {
          this.$message.error(`第${i + 1}行，数据不能为空`)
          this.buttonLoading = false
          return
        }

        if (this.dataList[i] && (this.dataList[i].start_time === this.dataList[i].end_time) && (parseFloat(this.dataList[i].start_time) != 23)) {
          this.$message.error(`第${i + 1}行，数据不能相等`)
          this.buttonLoading = false
          return
        }
      }

      let params

      if (this.dataList.length === 1) {
        if ((!this.dataList[0].start_time || this.dataList[0].start_time == 0) && (!this.dataList[0].end_time || this.dataList[0].end_time == 0)) {
          params = {
            data: '',
          };
        } else {
          params = {
            data: this.dataList
          }
        }
      } else {
        params = {
          data: this.dataList
        }
      }


      patchApiData('up_down', params)
        .then(res => {
          this.$message.success("保存成功！")
          this.closeConfigDialog()//关闭弹窗
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    closeConfigDialog() {
      //关闭弹窗
      this.$emit('close')
    },
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>